<script setup lang="ts">
/**
 * Single leaf, used as the marker riding the tip of the focus block bar's
 * green fill. Kept separate from {@link SproutGlyph} because it is a marker,
 * not the capability mark, and it is drawn at 10–12px where the sprout's stem
 * would collapse.
 *
 * `currentColor` throughout so the caller controls it against whatever the
 * fill has reached.
 */
withDefaults(defineProps<{ size?: number }>(), { size: 12 });
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6 10.5C6 6 8 2.5 11 1.5c0 4.5-2 8-5 9z" fill="currentColor" />
    <path
      d="M6 10.5C6 6.8 3.8 3.8 1 3c0 3.7 2.2 6.7 5 7.5z"
      fill="currentColor"
      opacity="0.75"
    />
  </svg>
</template>
